import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductCreateSerialnoComponent } from 'app/dialogs/product-create-serialno/product-create-serialno.component';
import { ProductMovementCreateComponent } from 'app/dialogs/product-movement-create/product-movement-create.component';
import { SubProductCreateComponent } from 'app/dialogs/sub-product-create/sub-product-create.component';
import { BrandService } from 'app/services/models/brand.service';
import { CategoryService } from 'app/services/models/category.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { LabelService } from 'app/services/models/label.service';
import { ProductSerialService } from 'app/services/models/product-serial.service';
import { ProductService } from 'app/services/models/product.service';
import { SubProductService } from 'app/services/models/sub-product.service';
import { TaxService } from 'app/services/models/tax.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { WarehouseService } from 'app/services/models/warehouse.service';
import { link } from 'fs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-detail-product',
  templateUrl: './detail-product.component.html',
  styleUrls: ['./detail-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DetailProductComponent implements OnInit {
  public contentHeader: object;
  data: any = {};
  productType: boolean = null;
  form: FormGroup;
  labelsText: string = '';
  public selectBasicLoading = false;


  public unitTypes: [];
  public currencies: [];
  public taxes: [];
  public categories: [];
  public warehoueses: [];
  brands: any[];

  constructor(
    private activatedRouter: ActivatedRoute,
    private router:Router,
    private producService: ProductService,
    private fb: FormBuilder,
    private unitTypeService: UnitTypeService,
    private currencyService: CurrencyService,
    private taxService: TaxService,
    private categoryService: CategoryService,
    private warehouseService: WarehouseService,
    private modalService: NgbModal,
    private subProductService: SubProductService,
    private toastrService: ToastrService,
    private labelService:LabelService,
    private productSerialService:ProductSerialService,
    private brandService: BrandService) { }

  @BlockUI('section-block') blockUI: NgBlockUI;
  isReadonly: boolean = true;

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Ürün Hizmet',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Ürün Hizmet Listesi',
            isLink: true,
            link: '/product'
          },
          {
            name: 'Ürün Hizmet Detay',
            isLink: false,
          },
        ]
      }

    }

    this.form = this.fb.group({
      name: [''],
      barcode: [''],
      code: [''],
      categoryName: [''],
      criticalStock: [''],
      currencyName: [''],
      unitTypeName: [''],
      purchasePrice: [''],
      saleTax: [''],
      salePrice: [''],
      purchaseTax: [''],
      productType: ['']
    });
    this.activatedRouter.params.subscribe(async params => {
      await this.getByIdProduct(params['id']);
      this.producService.event$.subscribe(async result => {
        await this.getByIdProduct(params['id']);
      })
    });
    await this.getAllUnitTypes(0, 100, "");
    await this.getAllCurrency(0, 100, "");
    await this.getAllTax(0, 100, "");
    await this.getAllCategory(0, 100, "");
    await this.getAllWarehouse(0, 100, "");
    await this.getAllBrand();
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );

    console.log(this.brands);

  }
  
  toggleReadonly() {
    this.isReadonly = !this.isReadonly;
  }

  eventDelete(){
    this.router.navigate(['/admin/product']);
  }

  showCrateProductMovement() {
    const modal = this.modalService.open(ProductMovementCreateComponent, {
      size: 'sm',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data ={
      productId: this.data.id,
      id:null
    };
  }

  showUpdateProductMovement(item){
    const modal = this.modalService.open(ProductMovementCreateComponent, {
      size: 'sm',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data ={
      productId: this.data.id,
      productMovement:item
    };
  }

  showSubProductCrate(){
    const modal = this.modalService.open(SubProductCreateComponent, {
      size: 'sm',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = this.data.id;
  }

  newLabel: string = '';
  addLabel(event: KeyboardEvent) {
    event.preventDefault(); // Prevent form submission on Enter key

    if (this.newLabel.trim()) {
      // Add the new label if it doesn't already exist
      if (!this.data.labels.some(label => label.labelName === this.newLabel.trim())) {
        this.data.labels.push({ labelName: this.newLabel.trim() });
      }
      // Clear the input field
      this.newLabel = '';
    }
  }

  async removeSubProducts(id) {
    const data = await this.subProductService.removeSubProduct(id);
    if (data.status == true) {
      this.producService.sendEvent(true);
      this.toastrService.success(data.message, "Alt Ürün Silindi.")
    } else {
      this.toastrService.error(data.message, "Alt Ürün Silinemedi.")
    }
  }

  async updateData() {
    this.blockUI.start('Ürün Güncelleniyor..');
    const labelsToSend = this.data.labels.filter(l=>!l.labelId).map(p=>p.labelName);
    console.log(this.data.brandModelId);
    try {
      const data = await this.producService.updateProduct({
        id : this.data.id,
        code :this.data.code,
        barcode : this.data.barcode,
        name : this.data.name,
        productType: this.data.productType,
        purchasePrice : this.data.purchasePrice,
        salePrice : this.data.salePrice,
        purchaseTaxId : this.data.purchaseTaxId,
        saleTaxId : this.data.saleTaxId,
        categoryId : this.data.categoryId,
        criticalStock : this.data.criticalStock,
        unitTypeId : this.data.unitTypeId,
        currencyId : this.data.currencyId,
        labels : labelsToSend,
        brandModelId : this.data.brandModelId
      });
      if(data.status == true){
        this.isReadonly = true;
        this.toastrService.success(data.message,"Ürün Bilgileri Güncelleme");
        this.producService.sendEvent(true);
      }else{
        this.toastrService.error(data.message,"Ürün Bilgileri Güncellenemedi.")
      }
    } catch (error) {
      console.error('Error updating product data:', error);
    } finally {
      this.blockUI.stop();
    }
  }

  updateProductType(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.data.productType = input.value === 'true';
  }

  removeLabel(productLabelId: number) {
    this.data.labels = this.data.labels.filter(label => label.labelId !== productLabelId);

    // Optionally call the backend API to remove the label
    this.removeLabelFromBackend(productLabelId);
  }

  saveLabelToBackend(labelId: number, labelName: string) {
    // Implement your backend call to save the label
    console.log(`Saving label to backend: ID=${labelId}, Name=${labelName}`);
  }

  async removeLabelFromBackend(labelId: number) {
    console.log(labelId);
    const data = await this.labelService.removeLabelProduct(labelId);
    if(data.status){
      this.producService.sendEvent(true);
    }  
  }

  async getByIdProduct(id) {
    this.blockUI.start('Ürün Yükleniyor..');
    const data = await this.producService.getByIdProduct(id);
    console.log(data);
    this.data = data;
    this.blockUI.stop();

  }

  async getAllUnitTypes(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.unitTypeService.getAllUnitType(0, 100, search);
    console.log(data.unitTypes);
    this.unitTypes = data.unitTypes
    this.selectBasicLoading = false;

  }

  async getAllCurrency(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.currencyService.getAllPageCurrency(0, 100, search);
    console.log(data);
    this.currencies = data.currenies
    this.selectBasicLoading = false;

  }

  createSerialNo() {
    const modalRefTransport = this.modalService.open(ProductCreateSerialnoComponent, {
      size: 'sm',
      windowClass: 'modal modal-warning'
    });
    modalRefTransport.componentInstance.data = this.data.id;
  }


  async getAllTax(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.taxService.getAllTax(0, 100, search);
    console.log(data);
    this.taxes = data.taxex
    this.selectBasicLoading = false;

  }

  async getAllCategory(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.categoryService.getAllCategory(0, 100, search, 1);
    console.log(data);
    this.categories = data.categories;
    this.selectBasicLoading = false;

  }

  async getAllWarehouse(page, size, search) {
    this.selectBasicLoading = true;
    const data = await this.warehouseService.getAllWarehouses(0, 100, search);
    console.log(data);
    this.warehoueses = data.warehouses;
    this.selectBasicLoading = false;
  }


  editingSubProductId: number | null = null;
  editingSerail: number | null = null;
  tempCount: number | null = null;
  serialNo: string | null = null;

  editSerial(item) {
    this.editingSerail = item.id;
    this.serialNo = item.serialNo;
    console.log(item); 
  }

  async saveProductSerial(item) {
    console.log(item);
    const data = await this.productSerialService.updateProductSerial(item.id,item.serialNo,this.data.id);
    if(data.status)
      {
        this.producService.sendEvent(true);
        this.toastrService.success(data.message,"Seri No güncellendi");
      }else{
        this.toastrService.error(data.message,"Seri No güncellenemedi");

      }
      this.cancelEdit();
  }
  async removeProductSerial(id) {
    console.log(id);
    const data = await this.productSerialService.removeProductSerial(id);
    console.log(data);

    if(data.status)
      {
        this.producService.sendEvent(true);
        this.toastrService.success(data.message,"Seri No Silme.");
      }else{
        this.toastrService.error(data.message,"Seri No Silme Başarısız.");

      }
      this.cancelEdit();
  }

  editSubProduct(item) {
    this.editingSubProductId = item.subProductId;
    this.tempCount = item.count;
  }

  

  async saveSubProduct(item) {
    if (this.tempCount !== null) {
      item.count = this.tempCount;
      console.log('Updated item:', item);
      const data = await this.subProductService.updateSubProduct(item.subProductId,item.connectedSubProductId,item.count);
      if(data.status)
      {
        this.producService.sendEvent(true);
        this.toastrService.success(data.message,"Alt ürün güncellendi");
      }else{
        this.toastrService.error(data.message,"Alt ürün güncellenemedi");

      }
    }
    this.cancelEdit();
    // Burada güncelleme işlemini API'ye gönderebilirsiniz
  }

  cancelEdit() {
    this.editingSubProductId = null;
    this.tempCount = null;
    this.editingSerail = null;
    this.serialNo = null;
  }

}
